import { STRETCH_MODAL_CONTENT_VIEWPORT_OFFSET_PX } from "@/constants/ui/stretch-modal-content.constants.ts";
import { ApiFile } from "@/types/common.types.ts";
import { DocumentPreviewModal, ModalProps } from "@skailer-com/uikit";
import { useCallback } from "react";

export interface PreboardingAttachmentPreviewModalProps extends ModalProps {
  file: ApiFile;
}

export function PreboardingAttachmentPreviewModal({
  file,
  ...modalProps
}: PreboardingAttachmentPreviewModalProps) {
  const url = file.url_permanent ?? null;
  const mimeType = file.mime_type.toLowerCase();
  const isPreviewable = mimeType === "application/pdf" || mimeType.startsWith("image/");

  const openInNewTab = useCallback(() => {
    if (url) window.open(url, "_blank", "noopener,noreferrer")?.focus();
  }, [url]);

  return (
    <DocumentPreviewModal
      {...modalProps}
      title={file.name}
      previewUrl={url}
      contentType={file.mime_type}
      fileName={file.name}
      status={url ? (isPreviewable ? "ready" : "unsupported") : "failed"}
      contentOffsetPx={STRETCH_MODAL_CONTENT_VIEWPORT_OFFSET_PX}
      onDownload={url ? openInNewTab : undefined}
      onOpenInNewTab={url ? openInNewTab : undefined}
    />
  );
}
